// #region Interfaces & Types
export interface UpsellPoints {
    title: string;
    description: string;
    icon: string;
}

export enum UpsellType {
    MarketConditions = 'MarketConditions',
    RateView = 'RateView',
}

export enum EquipmentType {
    VAN = 'VAN',
    REEFER = 'REEFER',
    FLATBED = 'FLATBED',
}
export interface UpsellButtonCta {
    title: string;
    link: string;
}
// #endRegion

// #region Market Conditions Upsell Models

export const marketConditionsUpsellTitle: string =
    'Data-driven decisions for your business.';
export const marketConditionsUpsellDescription: string =
    'Market Conditions can help you run your business more efficiently.';

export const marketConditionsUpsellPoints: UpsellPoints[] = [
    {
        title: 'Plan for the present and future',
        description:
            'See conditions for the past, present and future so you can plan for today and forecast for next week.',
        icon: 'diamond',
    },
    {
        title: 'Get precise details for a market or region',
        description:
            'You can zoom into any specific market to get precise details or take a big picture view of any entire region.',
        icon: 'diamond',
    },
    {
        title: 'See conditions for different vehicle types',
        description:
            'Whether you’re researching vans, reefers or flatbeds, you can see it all with your DAT Load Board and MCI.',
        icon: 'diamond',
    },
];

export const marketConditionsButtonCta: UpsellButtonCta = {
    title: 'LEARN MORE',
    link: '',
};

//#endRegion

// #region Rate View Upsell Models

export const rateViewUpsellTitle: string = 'Stay informed. Stay competitive.';
export const rateViewUpsellDescription: string =
    'RateView can help you run your business more efficiently.';

export const rateViewUpsellPoints: UpsellPoints[] = [
    {
        title: 'Get the most current market insights',
        description:
            'Navigate market volatility with the timeliest data available.',
        icon: 'diamond',
    },
    {
        title: 'See seasonal trends',
        description:
            'Analyze rate trends on new lanes, with comprehensive 13-month pricing histories.',
        icon: 'diamond',
    },
    {
        title: 'Compare spot and contract rates',
        description:
            'Relevant insights for brokers, shippers and carriers on any lane, based on the deepest, broadest data in the industry.',
        icon: 'diamond',
    },
];

export const rateViewButtonCta: UpsellButtonCta = {
    title: 'LEARN MORE',
    link: '',
};

// #endRegion

// #region Maps
export const colorMap: Record<EquipmentType, string> = {
    VAN: 'bg-dat-signal-yellow-100',
    REEFER: 'bg-dat-pool-100',
    FLATBED: 'bg-dat-regal-050',
};

export const buttonCtaMap: Record<UpsellType, UpsellButtonCta> = {
    MarketConditions: marketConditionsButtonCta,
    RateView: rateViewButtonCta,
};

export const UpsellTrackingEventName = 'Clicked To Learn More - iQ Upsell';

// #endRegion
